<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <button mat-raised-button routerLink="/loja" type="button" class="full-width-on-mobile">Continuar comprando</button>
      </div>

      <div *ngIf="carrinho?.itens?.length > 0" class="col-xs-12 informe-prazo" role="alert">
        Essa compra será avaliada pela equipe da tag2u, que entrará em contato com você para dar sequência ao pagamento. Aguarde o contato em até
        <b>24 horas úteis</b>.
      </div>

      <div *ngIf="carrinho?.itens?.length > 0" class="col-xs-12 informe-prazo" role="alert">
        Um representante entrará em contato para negociar o frete.
      </div>

      <section *ngIf="carrinho?.itens?.length == 0" class="card-empty col-xs-12">
        <ng-container *ngTemplateOutlet="Itens"></ng-container>
        <img class="empty-cart" src="../../../assets/images/CarrinhoVazio.svg" alt="" />
        <h2>Seu carrinho está vazio.</h2>
      </section>

      <section *ngIf="carrinho?.itens?.length > 0" class="col-xs-12">
        <div class="item-list">
          <mat-list>
            <app-item *ngFor="let item of carrinho?.itens" [item]="item"></app-item>
          </mat-list>
        </div>

        <div class="row">
          <div class="col-xs-12 col-md-8">
            <mat-card>
              <mat-card-content>
                <h1>Dados do cliente</h1>
                <form name="clienteForm" class="row" [formGroup]="formCliente">
                  <mat-form-field appearance="outline" class="col-xs-12 col-md-4">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="nome" type="text" id="nome" name="nome" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="col-xs-12 col-md-4">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" type="text" id="email" name="email" />
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="col-xs-12 col-md-4">
                    <mat-label> Contato </mat-label>
                    <input type="text" id="celular" mask="(XX) X XXXX-XXXX" name="celular" formControlName="celular" matInput />
                  </mat-form-field>
                </form>

                <form [formGroup]="formTransporte" class="row">
                  <h1 class="col-xs-12">Dados da entrega</h1>

                  <div class="col-xs-12">
                    <mat-slide-toggle
                      (change)="toggleFrete()"
                      [checked]="carrinho?.retirarNaLoja"
                      [disabled]="desabilitarRetiradaNaLoja"
                      color="primary"
                    >
                      Retirar na loja
                    </mat-slide-toggle>
                  </div>

                  <br />

                  <section *ngIf="!carrinho?.retirarNaLoja" class="col-xs-12">
                    <div class="row">
                      <mat-form-field appearance="outline" class="col-md-3 col-xs-12">
                        <mat-label>CEP</mat-label>
                        <input matInput type="text" mask="00000-000" formControlName="cep" name="cep" />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="col-md-6 col-xs-12">
                        <mat-label>Rua</mat-label>
                        <input matInput type="text" autocomplete="off" formControlName="logradouro" name="rua" />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="col-md-3 col-xs-12">
                        <mat-label>Numero</mat-label>
                        <input matInput class="text" type="text" autocomplete="off" formControlName="numero" name="numero" />
                      </mat-form-field>
                    </div>

                    <div class="row">
                      <mat-form-field appearance="outline" class="col-md-6 col-xs-12">
                        <mat-label>Complem.</mat-label>
                        <input matInput type="text" autocomplete="off" formControlName="complemento" name="complemento" />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="col-md-6 col-xs-12">
                        <mat-label>Bairro</mat-label>
                        <input matInput type="text" autocomplete="off" name="bairro" formControlName="bairro" />
                      </mat-form-field>
                    </div>

                    <div class="row">
                      <mat-form-field appearance="outline" class="col-md-4 col-xs-12">
                        <mat-label>Cidade</mat-label>
                        <input
                          matInput
                          type="text"
                          autocomplete="off"
                          name="cidade"
                          formControlName="cidade"
                          [disabled]="transporte?.logradouro !== undefined"
                        />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="col-md-4 col-xs-12">
                        <mat-label>Estado</mat-label>
                        <input
                          matInput
                          type="text"
                          autocomplete="off"
                          name="estado"
                          formControlName="estado"
                          [disabled]="transporte?.logradouro !== undefined"
                        />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="col-md-4 col-xs-12">
                        <mat-label> Tipo de acesso </mat-label>
                        <mat-select formControlName="tipoAcesso" id="tipoAcesso" name="tipoAcesso">
                          <mat-option *ngFor="let acesso of TIPOACESSO" [value]="acesso?.value"> {{ acesso?.text }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </section>
                </form>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="col-xs-12 col-md-4">
            <mat-card>
              <mat-card-content>
                <h1>Detalhes da venda</h1>
                <p>
                  Quantidade: {{ carrinho?.itens?.length }} <br />
                  Valor dos Itens: {{ carrinho?.valorTotalDosItensSemFrete.toString() | currency : 'BRL' }} <br />
                  Valor do Frete: {{ carrinho?.valorFrete.toString() | currency : 'BRL' }} <br />
                  Total: {{ carrinho?.valorTotalDosItensComFrete.toString() | currency : 'BRL' }}
                </p>
              </mat-card-content>
              <mat-card-actions>
                <button mat-raised-button type="submit" [disabled]="desabilitarProsseguirParaPagamento" (click)="finalizarVenda()">
                  Prosseguir para pagamento
                </button>
              </mat-card-actions>
            </mat-card>
          </div>
        </div>

        <ng-template #Itens> </ng-template>
      </section>
    </div>
  </div>
</section>
